module.exports = __webpack_public_path__ + "assets/images/albom10.a230f6d5.jpg";